import { isEmpty } from 'lodash';
import dayjs from 'dayjs';

const DAY_MAP = {
  0: 'SUNDAY',
  1: 'MONDAY',
  2: 'TUESDAY',
  3: 'WEDNESDAY',
  4: 'THURSDAY',
  5: 'FRIDAY',
  6: 'SATURDAY'
};

const SHORT_DAY_MAP = {
  0: 'SUN',
  1: 'MON',
  2: 'TUE',
  3: 'WED',
  4: 'THU',
  5: 'FRI',
  6: 'SAT'
};

const MONTH_MAP = {
  0: {
    short: 'JAN',
    long: 'JANUARY'
  },
  1: {
    short: 'FEB',
    long: 'FEBRUARY'
  },
  2: {
    short: 'MAR',
    long: 'MARCH'
  },
  3: {
    short: 'APR',
    long: 'APRIL'
  },
  4: {
    short: 'MAY',
    long: 'MAY'
  },
  5: {
    short: 'JUN',
    long: 'JUNE'
  },
  6: {
    short: 'JUL',
    long: 'JULY'
  },
  7: {
    short: 'AUG',
    long: 'AUGUST'
  },
  8: {
    short: 'SEP',
    long: 'SEPTEMBER'
  },
  9: {
    short: 'OCT',
    long: 'OCTOBER'
  },
  10: {
    short: 'NOV',
    long: 'NOVEMBER'
  },
  11: {
    short: 'DEC',
    long: 'DECEMBER'
  }
};

const formatTime = (input) => {
  const totalMinutes = parseFloat(input) * 60;

  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.round(totalMinutes % 60);

  let displayValue = null;

  if (hours && minutes) {
    displayValue = `${hours}h ${minutes}m`;
  } else if (hours && !minutes) {
    displayValue = `${hours}h`;
  } else if (!hours && minutes) {
    displayValue = `${minutes}m`;
  }

  return {
    time: input, // Value from API
    hours: hours.toString(), // Hour in string
    minutes: minutes.toString(), // Minutes in string
    displayValue // Show time in H:M format
  };
};

const getWorkData = (
  workData,
  primaryAdditionalValues,
  secondaryAdditionalvalues
) => {
  // This function will recieve array of data on a specific date and returns the workData in specific format
  let work = {};
  let values = [];
  if (workData?.attribute === 'item.workItem.workId') {
    const workId = workData?.label;
    const id = workData?.label;
    work = Object.assign(work, { workId, id });
    // work = { ...work, workId, id };
    if (
      primaryAdditionalValues &&
      workData?.additionalValues &&
      Array.isArray(workData?.additionalValues)
    ) {
      workData?.additionalValues.forEach((data, index) => {
        const key = primaryAdditionalValues[index] || 'noKey';
        work = Object.assign(work, { [key]: data });
        // work = { ...work, [key]: data };
      });
    }
  }

  if (workData?.data && Array.isArray(workData?.data)) {
    workData?.data?.forEach((el) => {
      if (el?.attribute === 'event.endTime') {
        let valuesData = {};
        const fullDate = el?.value || null;
        const date = el?.originalLabel || null;
        valuesData = Object.assign(valuesData, { fullDate, date });
        // valuesData = { fullDate, date };

        if (
          secondaryAdditionalvalues &&
          el?.additionalValues &&
          Array.isArray(el?.additionalValues)
        ) {
          el?.additionalValues.forEach((data, index) => {
            const key = secondaryAdditionalvalues[index] || 'noKey';
            valuesData = Object.assign(values, { [key]: data });
            // valuesData = { ...valuesData, [key]: data };
          });
        }

        if (el?.data && Array.isArray(el?.data)) {
          el?.data?.forEach((el) => {
            if (el?.type === 'metrics') {
              if (el?.data) {
                el?.data?.forEach((metricData) => {
                  if (metricData?.attribute === 'timespent') {
                    if (
                      metricData?.value &&
                      !isNaN(parseFloat(metricData?.value)) &&
                      parseFloat(metricData?.value) > 0
                    ) {
                      const timeData = formatTime(metricData?.value);
                      valuesData = Object.assign(valuesData, timeData);
                    } else {
                      valuesData = Object.assign(valuesData, {
                        time: null,
                        hours: null,
                        minutes: null,
                        displayValue: null
                      });
                    }
                  } else {
                    const key = metricData?.attribute || 'noKey';
                    const value = metricData?.value || 'null';
                    valuesData = Object.assign(valuesData, { [key]: value });
                  }
                });
              }
            }
          });
        }
        values.push(valuesData);
      }
    });
  }

  let totalTime = 0;
  values.forEach((el) => {
    let time = 0;
    if (parseFloat(el?.time)) {
      time = parseFloat(el?.time);
    }
    totalTime = time + totalTime;
  });

  const formattedTotalTime = formatTime(totalTime);

  let entityData = {
    totalTime: formattedTotalTime,
    work,
    values
  };
  return entityData;
};

const getTotalTimeData = (transformedData, weekrange) => {
  let totalData = [];

  if (weekrange && transformedData) {
    weekrange.forEach((day) => {
      let dayData = day;
      let workData = [];

      transformedData.forEach((data) => {
        const values = data.values.find((val) => day?.date === val?.date);
        if (values) {
          workData.push({
            work: data?.work,
            values: values
          });
        }
      });

      let totalDayHours = 0;
      workData.forEach((work) => {
        if (work?.values) {
          let time = 0;
          if (parseFloat(work?.values?.time)) {
            time = parseFloat(work?.values?.time);
          }
          totalDayHours = time + totalDayHours;
        }
      });

      totalDayHours = formatTime(totalDayHours);

      dayData = {
        id: day?.date,
        day,
        workData,
        totalDayHours
      };
      totalData.push(dayData);
    });
  }

  totalData.forEach((el) => {});
  return totalData;
};

const transformationFunction = (
  APIData,
  primaryAdditionalValues,
  secondaryAdditionalvalues,
  weekRange
) => {
  // This function transforms the API data to the desired format,
  // APIData - API Response;
  // primaryAdditionalValues - Additional values for the first nesting query in API
  // secondaryAdditionalvalues - Additional values for the second nesting query in API
  // DateRange - Date in week

  const moduleData = [];
  let weeklyHours = 0;

  APIData.forEach((workData) => {
    let entityData = {};
    const formattedData = getWorkData(
      workData,
      primaryAdditionalValues,
      secondaryAdditionalvalues
    );
    entityData = { ...entityData, ...formattedData };
    moduleData.push(entityData);
  });

  const reportData = getTotalTimeData(moduleData, weekRange) || null;

  if (reportData && reportData?.length > 0) {
    reportData.forEach((el) => {
      const dayHour = el?.totalDayHours?.time;
      if (parseFloat(dayHour)) {
        weeklyHours = weeklyHours + parseFloat(dayHour);
      }
    });
  }

  if (weeklyHours) {
    weeklyHours = formatTime(weeklyHours);
  }

  return {
    workData: moduleData, // FOR CALENDER AND OTHERS
    reportData: reportData, // FOR REPORT
    weeklyHours: weeklyHours
  };
};

const getDayDetails = (inputDate) => {
  const date = new Date(inputDate).toISOString().slice(0, 10);
  const day = DAY_MAP?.[new Date(inputDate).getUTCDay()];
  const number = new Date(inputDate).getUTCDate();
  const shortDay = SHORT_DAY_MAP?.[new Date(inputDate).getUTCDay()];
  const isToday = dayjs(dayjs(inputDate).format('YYYY-MM-DD')).isSame(
    dayjs().format('YYYY-MM-DD')
  );
  const month = MONTH_MAP?.[new Date(inputDate).getMonth()];
  const year = new Date(inputDate).getFullYear();
  const IsoDate = new Date(inputDate).toISOString().slice(0, 16);
  let startTime = new Date(inputDate);
  startTime.setUTCHours(0, 0, 0, 0);
  startTime = startTime.toISOString().slice(0, 23);

  let endTime = new Date(inputDate);
  endTime.setUTCHours(23, 59, 59, 999);
  endTime = endTime.toISOString().slice(0, 23);

  return {
    date,
    day,
    number,
    shortDay,
    isToday,
    shortMonth: month?.short,
    longMonth: month?.long,
    year,
    IsoDate,
    startTime,
    endTime
  };
};

const getWeekRangeNew = (weekRange) => {
  // We pass in date as "2022-03-25" and we get the week data starting from monday
  const week = [];

  weekRange.forEach((day) => {
    const dayDetails = getDayDetails(day);
    week.push(dayDetails);
  });

  return week;
};

const transfromBusinessHour = (APIData) => {
  const data = [];
  APIData.forEach((el) => {
    const day = el?.label;
    const date = el?.originalLabel;
    const dayData = getDayDetails(date);
    let hoursData = {};

    const metricData = el?.data.find((m) => m.type === 'metrics')?.data;
    if (metricData && !isEmpty(metricData)) {
      metricData.forEach((hours) => {
        const afterHours = hours?.metricId === '1';
        const businessHours = hours?.metricId === '2';
        const nonBillableHours = hours?.metricId === '3';
        const billableHours = hours?.metricId === '4';

        if (afterHours) {
          const afterHoursData = {
            afterHours: true,
            timespent: hours?.value,
            formattedTime: formatTime(hours?.value)
          };
          hoursData = { ...hoursData, afterHoursData };
        } else if (businessHours) {
          const businessHoursData = {
            afterHours: false,
            timespent: hours?.value,
            formattedTime: formatTime(hours?.value)
          };
          hoursData = { ...hoursData, businessHoursData };
        } else if (nonBillableHours) {
          const nonBillableData = {
            billable: false,
            timespent: hours?.value,
            formattedTime: formatTime(hours?.value)
          };
          hoursData = { ...hoursData, nonBillableData };
        } else if (billableHours) {
          const billableData = {
            billable: true,
            timespent: hours?.value,
            formattedTime: formatTime(hours?.value)
          };
          hoursData = { ...hoursData, billableData };
        }
      });
    }
    data.push({
      dayData,
      date,
      day,
      ...hoursData
    });
  });
  return data;
};

export {
  transformationFunction,
  formatTime,
  getDayDetails,
  transfromBusinessHour,
  getWeekRangeNew
};
